import { useCompanyDocumentFolders } from "@/modules/documents/entities/company-document-folder-select";

/**
 * Родитель папки закрыт защитой: его id пришёл, а среди доступных папок его нет.
 * Выбор родителя тогда показал бы голый id, а очистка молча вынесла бы папку
 * в корень из папки, которую пользователь даже не видит.
 */
export function useIsParentHidden(parentId?: string | null) {
  const { folders, loading } = useCompanyDocumentFolders();

  return (
    !!parentId && !loading && !folders.some((folder) => folder.id === parentId)
  );
}
